import { IFetchPendencySimulationsDTO } from 'modules/customer/domain/dtos';
import { IPendencySimulationsRepository } from 'modules/customer/domain/repositories';

export class FetchPendencySimulationsUseCase {
  constructor(
    private pendencySimulationsRepository: IPendencySimulationsRepository,
  ) {}

  public async execute({
    customerId,
    unitId,
    accounts,
  }: IFetchPendencySimulationsDTO) {
    return this.pendencySimulationsRepository.findAll({
      customerId,
      unitId,
      accounts,
    });
  }
}
